import { createSlice } from '@reduxjs/toolkit';

export const pdfSlice = createSlice({
  name: 'pdfSlice',
  initialState: {
    fileBinary: null,
    fileId: null,
  },
  reducers: {
    addFileBinary: (state, action) => {
      state.fileBinary = action.payload;
    },
    addFileId: (state, action) => {
      state.fileId = action.payload;
    },
  },
  extraReducers() {},
});

// ACTIONS
export const { addFileBinary, addFileId } = pdfSlice.actions;

// SELECTORS
export const getPdf = (state) => {
  return {
    ...state.pdfSlice,
  };
};
